import Cookies from 'js-cookie'

module.exports = () => {
  try {
    return JSON.parse(Cookies.get('unconfirmedPurchases')) || []
  } catch (e) {
    return []
  }
}
